// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3fg1y","loaderOuter":"PageOverlayLoader_loaderOuter__21L7o"};